const artifactMarkerTypes = {
	CHAPTER: "chapter",
	SPLIT: "split",
};

export default artifactMarkerTypes;
